import { WorkflowStatus } from '../graphql/generated';
export const ALL_WORKFLOW_STATUSES = Object.values(WorkflowStatus);
//# sourceMappingURL=workflow-status.js.map